import { render } from "./VacancyVideoDetailPage.vue?vue&type=template&id=9bf73ef8"
import script from "./VacancyVideoDetailPage.vue?vue&type=script&lang=js"
export * from "./VacancyVideoDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__